import React from 'react';
import {
  Container, Grid, Alert, AlertTitle, Skeleton,
} from '@mui/material';
import { BackNavigationAppBar, ZAvatar } from '@marageti/z4-lib';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { Traveler } from '@marageti/z4-sdk/lib/people';
import TravelerReviews from './traveler-reviews';
import TravelerCard from './traveler-card';

type Props = {
  error?: ApiError;
  hidePhone: boolean;
  isLoadingTr: boolean;
  traveler?: Traveler;
};

const TravelerView = ({
  error = undefined, hidePhone, isLoadingTr, traveler = undefined,
}: Props) => (
  <>
    <BackNavigationAppBar defaultPath="../../" primary="" />
    <Container maxWidth="lg">
      <Grid container spacing={7.5}>
        <Grid item mobile={12} desktop={4} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {!error && (
            <>
              <ZAvatar
                loading={isLoadingTr}
                size={128}
                src={traveler?.avatar}
                alt={traveler?.fullName}
                name={traveler?.fullName}
                sx={{ mb: 3 }}
              />
              {isLoadingTr ? (
                <Skeleton height={364} width={337} variant="rounded" sx={{ mb: 3 }} />
              ) : (
                <TravelerCard hidePhone={hidePhone} traveler={traveler!} />
              )}
            </>
          )}
          {error && (
            <Alert severity="error">
              <AlertTitle>There was an error getting the traveler.</AlertTitle>
              {`Code: ${error.code}: ${error.message}`}
              <br />
              {error.id && `ID: ${error.id}`}
            </Alert>
          )}
        </Grid>
        <Grid item mobile={12} desktop={7}>
          <TravelerReviews travelerName={traveler?.givenName || ''} />
        </Grid>
      </Grid>
    </Container>
  </>
);

export default TravelerView;
